import {gql, useMutation, useQuery} from '@apollo/client';

import {
  ChangePasswordQuery,
  UpdateUserPasswordInput,
  UpdateUserPasswordMutation,
  UpdateUserPasswordMutationVariables,
} from '#apollo/schema';
import {useAuth} from '#hook';

const changePasswordQuery = gql`
  query ChangePasswordQuery {
    me {
      id
      userProfile {
        id
        email
      }
    }
  }
`;

const updateUserPasswordMutation = gql`
  mutation UpdateUserPasswordMutation($input: UpdateUserPasswordInput!) {
    updateUserPassword(input: $input) {
      success
    }
  }
`;

export const useChangePassword = () => {
  const {signIn} = useAuth();
  const {data, loading} = useQuery<ChangePasswordQuery>(changePasswordQuery);
  const email = data?.me?.userProfile?.email;

  const [updateUserPassword] = useMutation<
    UpdateUserPasswordMutation,
    UpdateUserPasswordMutationVariables
  >(updateUserPasswordMutation);

  const handleSubmitUserPassword = async (input: UpdateUserPasswordInput) => {
    if (email) {
      const res = await updateUserPassword({
        variables: {input},
      });

      if (res.errors) {
        throw new Error(res.errors[0].message);
      }

      // Re-authenticate the user because Firebase invalidates tokens with the old password.
      await signIn({email, password: input.newPassword}, {rememberAuth: true});
    }
  };

  return {
    loading,
    handleSubmitUserPassword,
  };
};
